uniform sampler2D tBackground;
uniform vec2 uGlowPosition;
uniform float uGlowRadius;
uniform vec3 uGlowColor;
uniform float uGlowAlpha;

varying vec2 vUv;

void main()
{
    // Couleur de base du floor
    vec4 backgroundColor = texture(tBackground, vUv);
    
    // Calcul de l'effet de glow
    float glowStrength = distance(vUv, uGlowPosition) / uGlowRadius;
    glowStrength = 1.0 - glowStrength;
    glowStrength *= uGlowAlpha;
    glowStrength = clamp(glowStrength, 0.0, 1.0);
    
    // Mélange de la couleur du floor avec la couleur de glow
    vec3 finalColor = mix(backgroundColor.rgb, uGlowColor, glowStrength);
    
    // Rendu de la couleur finale
    gl_FragColor = vec4(finalColor, 1.0);
}

